var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYarnBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 160,
    viewBox: "0 0 180 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.8467,
    cy: 60.8467,
    r: 60.8467,
    transform: "matrix(-1 0 0 1 174.152 14.2803)",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.462 37.9805C162.462 37.9805 128.517 88.1656 77.401 123.042",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.029 28.0463C120.029 28.0463 111.133 21.1101 107.611 15.6286",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.581 39.8868C109.581 39.8868 97.651 30.9977 89.9742 18.6266",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5747 62.4875C91.5747 62.4875 73.3622 52.1335 65.0984 36.0113",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2703 72.1667C81.2703 72.1667 65.6636 63.7977 57.1824 48.079",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8437 82.6842C69.8437 82.6842 58.3574 76.2623 52.3525 65.1929",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.501 104.04C141.685 113.639 156.374 116.51 156.374 116.51",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.106 115.696C128.627 126.366 140.864 128.906 140.864 128.906",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.184 16.8632C130.184 16.8632 103.061 59.2945 55.0566 91.3693",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.349 26.0771C148.349 26.0771 116.715 72.9827 63.5071 110.218",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.913 55.9861C169.913 55.9861 140.314 103.688 94.165 131.734",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.613 90C155.798 99.5989 170.487 102.47 170.487 102.47",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.613 73C165.421 80.6409 176.11 81.7225 176.11 81.7225",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.223 50.4763C102.223 50.4763 84.0102 40.1222 75.7464 24",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 107.5C64.2033 107.5 62 116.109 57.1321 118.021C55.4069 118.699 54.3694 119.736 52.4307 119.952C49.1724 120.314 46.1797 120.931 42.86 120.931C30.0676 120.931 7.00209 118.541 4.74505 102.126C4.1606 97.8752 2.37731 90.094 7.87931 88.1894C14.432 85.9212 21.3079 86.7863 26.2652 91.7435C28.3415 93.8198 30.3656 98.0561 30.8266 100.95C31.9252 107.847 31.9738 116.015 30.5468 122.89C29.1958 129.399 28.5375 136.195 26.2931 142.479C24.3571 147.9 21.8136 153.062 19.241 158.207",
    stroke: "#5B3B52",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYarnBlack);
export default __webpack_public_path__ + "static/media/yarn-black.d53d748c94783cbccc6713ff3e6c251c.svg";
export { ForwardRef as ReactComponent };